let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3X49S")).then(() => parcelRequire('dIr09'));